module.exports = __webpack_public_path__ + "static/shine-on-zoom-968401197de25bca7c2fae67dc679ca7.jpg";